import React from "react";
import dayjs from 'dayjs';
import { convertTimeToLocation } from "../common/constant/constant";

const ChatTrialList = ({ data, onSelectChat, selectedChatId, trialName,trialList, onSearch, query, onClear, lastmessage }) => {

  const truncate = (text, limit) => {
    if (text) {
      return text.length > limit ? text.substring(0, limit) + "..." : text;
    }
  };

const formatTime = (timeString) => {
  const formattedDateTime = dayjs(timeString).format("MM[/]DD [at] hh:mm A");
  return formattedDateTime === "Invalid Date" ? "" : formattedDateTime;
};

  return (
    <div className="bg-white left-list-conversation w-[390px] h-full chat-trials-list">
      {/* Search Box */}
      <div className="p-4">
        <div className="flex items-center border rounded-lg p-2 table_border h-[44px] text-[#87909e]">
          <span className="text-[000000]"><svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.35 4.35a7.5 7.5 0 0012.3 12.3z"
            />
          </svg>
          </span>
          <input
            type="text"
            placeholder="Search by name"
            className="w-full outline-none ml-2 text-sm"
            onChange={(e) => onSearch(e.target.value)}
          />
          {query && (
            <button
              onClick={onClear}
              style={{
                position: "relative",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                color: "#999",
              }}
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Chat List */}
      <div className="grid">
        <div className="flex flex-col justify-between bg-white">
          <div className="flex flex-col justify-between bg-white">
          {trialList.map(
                (tn) => (
                    <div className={`relative flex cursor-pointer pl-4 items-center justify-between h-[82px] bg-white hover:bg-[#F1F1FD] allChatList pr-5
                          ${tn.patientTrialJuncID === selectedChatId ? 'active' : ''}`} 
                          onClick={() => onSelectChat(tn.patientTrialJuncID)} style={{color: '#667783'}}>
                        <div className="h-full w-full flex items-left justify-center flex-col text-left" style={{color: '#667783'}}>
                            <p className="big-text justify-between">
                              {truncate(tn.trialName,13)}
                              <span className="text-xs mt-1 whitespace-nowrap">{formatTime(convertTimeToLocation(tn.messageAt))}</span>
                            </p>
                            <p className="small-text text-xs text-gray-500 block truncate w-3/4 mt-[6px] cursor-pointer">
                                {truncate(tn.msgContent, 35)}
                            </p>
                        </div>
                    </div>
                )
              )}

          </div>
        </div>

      </div>
    </div>
  );
};

export default ChatTrialList